export default {
      id: "income-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#income",
      toString: function () {
        return this.url;
      }
    }